import { Graph, Node, Point } from '@antv/x6'

// 定义性别常量
const male = '/img/x6icon/avatar.png'
const female = '/img/x6icon/avatar.png'

const commandSystems = [
  {
    "id": 1234567890,
    "planId": 1234567890,
    "planVersion": 1,
    "parentId": 0,
    "organizationName": "指挥体系名称",
    "responsiblePersonId": 1234567890,
    "responsiblePersonName": "负责人姓名",
    "responsiblePersonContact": "联系电话",
    "mainDuties": "主要职责",
    "commandRole": "指挥角色",
    "children": [
    ]
  }
]

export default {
    data() {
      return {
        graph: null,
        mixinMessage: 'Hello from mixin!'
      }
    },
    created() {
      console.log('混入对象的钩子被调用！');
      console.log(this.$refs['GraphContainer'])
    },

  // resource-management
    methods: {    initX6(){
      setTimeout(() => {
        this.registerNode()
        this.graph = new Graph({
            container: this.$refs['GraphContainer'],
            autoResize: true,
            background: {
              color: '#F2F7FA',
            },
            grid: {
              visible: true,
              type: 'doubleMesh',
              args: [
                {
                  color: '#eee', // 主网格线颜色
                  thickness: 1, // 主网格线宽度
                },
                {
                  color: '#ddd', // 次网格线颜色
                  thickness: 1, // 次网格线宽度
                  factor: 4, // 主次网格线间隔
                },
              ],
            },
            })
            commandSystems.forEach((item,index) => {
              this.member(10 + 100 * index, item.y, item.organizationName, item.commandRole, male)
            })
            const bart = this.member(300, 70, '应急处置专项组', '类型', male)
            const homer = this.member(90, 200, '应急处置专项组', '类型', male)
            const marge = this.member(300, 200, '应急处置专项组', '类型', female)
            const lisa = this.member(500, 200, '应急处置专项组', '类型', female)
            const maggie = this.member(400, 350, '应急处置专项组', '类型', female)
            const lenny = this.member(190, 350, '应急处置专项组', '类型', male)
            const carl = this.member(190, 500, '应急处置专项组', '类型', male)
            
            this.link(bart, marge, [
              {
                x: 385,
                y: 180,
              },
            ])
            this.link(bart, homer, [
              {
                x: 385,
                y: 180,
              },
              {
                x: 175,
                y: 180,
              },
            ])
            this.link(bart, lisa, [
              {
                x: 385,
                y: 180,
              },
              {
                x: 585,
                y: 180,
              },
            ])
            this.link(homer, lenny, [
              {
                x: 175,
                y: 380,
              },
            ])
            this.link(homer, carl, [
              {
                x: 175,
                y: 530,
              },
            ])
            this.link(marge, maggie, [
              {
                x: 385,
                y: 380,
              },
            ])
            this.graph.zoomToFit({ padding: 20, maxScale: 1 })
            this.graph.on('node:click', ({ e, x, y, node, view }) => {
              console.log('node',node)
              this.formVisible = true
            })
      },500)
      
  },
      member( x,y,rank,name,image = male){
        return this.graph.addNode({
          x,
          y,
          shape: 'org-node',
          attrs: {
            avatar: {
              opacity: 0.7,
              'xlink:href': image,
            },
            rank: {
              text: rank,
              wordSpacing: '-5px',
              letterSpacing: 0,
            },
            name: {
              text: name,
              fontSize: 13,
              fontFamily: 'Arial',
              letterSpacing: 0,
            },
          },
        })
      },
      link(source,target,vertices){
        return this.graph.addEdge({
          vertices,
          source: {
            cell: source,
          },
          target: {
            cell: target,
          },
          shape: 'org-edge',
        })
      },
      registerNode(){
        Graph.registerNode(
          'org-node',
          {
            width: 180,
            height: 60,
            markup: [
              {
                tagName: 'rect',
                selector: 'body',
              },
              {
                tagName: 'image',
                selector: 'avatar',
              },
              {
                tagName: 'text',
                selector: 'rank',
              },
              {
                tagName: 'text',
                selector: 'name',
              },
            ],
            attrs: {
              body: {
                refWidth: '100%',
                refHeight: '100%',
                fill: '#618dff',
                stroke: '#f5ba18',
                strokeWidth: 2,
                rx: 10,
                ry: 10,
                pointerEvents: 'visiblePainted',
              },
              avatar: {
                width: 48,
                height: 48,
                refX: 8,
                refY: 6,
              },
              rank: {
                refX: 0.9,
                refY: 0.2,
                fill: '#fff',
                fontFamily: 'Courier New',
                fontSize: 14,
                textAnchor: 'end',
                textDecoration: 'underline',
              },
              name: {
                refX: 0.9,
                refY: 0.6,
                fill: '#fff',
                fontFamily: 'Courier New',
                fontSize: 14,
                fontWeight: '800',
                textAnchor: 'end',
              },
            },
          },
          true,
        )
        
        Graph.registerEdge(
          'org-edge',
          {
            zIndex: -1,
            attrs: {
              line: {
                fill: 'none',
                strokeLinejoin: 'round',
                strokeWidth: 2,
                stroke: '#20232b',
                sourceMarker: null,
                targetMarker: null,
              },
            },
          },
          true,
        )
    }
  }
}